var _mask, _g, _g2, _g3, _g4, _path, _g5, _path2, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950103990(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    stroke: "#2A3544"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 23,
    rx: 16.5,
    ry: 18,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51 36.76c-7.4 4.29-17 1.55-21.42-6.1",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 52.5,
    rx: 16.5,
    ry: 14.5,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    stroke: "#2A3544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.6 60.42c-4.27-7.41-13.95-9.84-21.6-5.42",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.5,
    cy: 22.5,
    rx: 16.5,
    ry: 15.5,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "sidesCables02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 138,
    height: 72
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 16,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 60,
    width: 16,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 42,
    width: 16,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    width: 16,
    height: 22,
    rx: 2
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesCables02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "topPyramid-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 64,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m50 8 32 44H18L50 8Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#topPyramid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M50 4h30v48H50z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceRound02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31v-1c.18-.48.4-1.5 1-3 .83-3.06 2.78-6.56 6-10C16.7 6.6 35.17 0 65 0s48.3 6.6 58 17c3.22 3.44 5.17 6.94 6 10 .6 1.5.82 2.52 1 3v40c0-.1-.03.5 0 1a53.93 53.93 0 0 1-1 6c-1.19 6-3.4 11.91-7 17-9.72 16.34-27.74 26-57 26s-47.28-9.66-57-26C4.4 88.91 2.2 83 1 77a53.95 53.95 0 0 1-1-6c.03-.45 0-1.32 0-1V31Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceRound02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h138v124H-4V-2Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 68,
    height: 22,
    rx: 5,
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 60,
    height: 14,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M18 9h4v14h-4zM42 9h4v14h-4zM30 9h4v14h-4zM54 9h4v14h-4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 104,
    height: 32,
    rx: 16,
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 22,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950103990);
export default __webpack_public_path__ + "static/media/bottts-1767950103990.d094510b710258f742e660f3639ac0c3.svg";
export { ForwardRef as ReactComponent };